import { render, staticRenderFns } from "./CreateDetail_IV.vue?vue&type=template&id=52ccfa3d"
import script from "./CreateDetail_IV.vue?vue&type=script&lang=js"
export * from "./CreateDetail_IV.vue?vue&type=script&lang=js"
import style0 from "./CreateDetail_IV.vue?vue&type=style&index=0&id=52ccfa3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports